import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { exportTableToExcel } from "../utils/exportTableToExcel";
import "./globalList.scss";
import Url from "../global";
import * as FaIcons from "react-icons/fa";

const RiwayatKeluargaList = () => {
  const [riwayatKeluargas, setRiwayatKeluarga] = useState([]);
  const { pegawai } = useSelector((state) => state.auth);
  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("");
  const [order, setOrder] = useState("ASC");

  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...riwayatKeluargas].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      );
      setRiwayatKeluarga(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...riwayatKeluargas].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      );
      setRiwayatKeluarga(sorted);
      setOrder("ASC");
    }
  };

  useEffect(() => {
    getRiwayatKeluarga();
  }, []);

  const getRiwayatKeluarga = async () => {
    const response = await axios.get(`${Url}/riwayat_keluargas`);
    setRiwayatKeluarga(response.data);
  };

  const deleteRiwayatKeluarga = async (riwayatKeluargaId) => {
    await axios.delete(`${Url}/riwayat_keluargas/${riwayatKeluargaId}`, {
      credentials: "include",
    });
    getRiwayatKeluarga();
  };

  const download = (e) => {
    console.log(e.target.href);
    fetch(e.target.href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const blob = new Blob([buffer]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Akta Kelahiran.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <h1 className="title">Riwayat Keluarga</h1>
      {/* <h2 className="subtitle">List Of Riwayat Keluarga</h2> */}

      {pegawai &&
        (pegawai.strRole === "user" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "staff TU" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "admin") && (
          <Link to="/riwayat-keluarga/add" className="button is-primary mb-2">
            Add New Riwayat Keluarga
          </Link>
        )}
      <button
        type="button"
        className="download-table-xls-button"
        onClick={() =>
          exportTableToExcel({
            tableId: "table-to-xls",
            filename: "Table Riwayat Keluarga",
          })
        }
      >
        Download as XLS
      </button>

      <br />
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && <label> Masukan Nama </label>}
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <input
            className="search"
            placeholder="Cari Nama Individu"
            onChange={(e) => setQuery(e.target.value.toLowerCase())}
          />
        )}
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <label className="label-unit">Masukan Unit </label>
        )}

      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <input
            className="search"
            placeholder="Cari Berdasarkan Unit"
            onChange={(e) => setQuery2(e.target.value.toLowerCase())}
          />
        )}
      <div className="table__wrapper_Scroll_Log">
        <table
          className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
          id="table-to-xls"
        >
          <thead>
            <tr>
              <th className="has-text-centered">No</th>
              <th className="has-text-centered">Nama Lengkap</th>
              <th className="has-text-centered">Status Keluarga</th>
              <th className="has-text-centered">Tempat Lahir</th>
              <th className="has-text-centered">Tanggal Lahir</th>
              <th className="has-text-centered">Pekerjaan</th>
              <th className="has-text-centered">Detail Pekerjaan / instansi</th>
              <th className="has-text-centered">Nomor BPJS Keluarga</th>
              <th className="has-text-centered">Akta Kelahiran</th>
              <th
                className="has-text-centered"
                onClick={() => sorting("strStatus")}
              >
                Status <FaIcons.FaSort />
              </th>
              <th className="has-text-centered">Komentar</th>
              <th className="has-text-centered">Created by</th>
              <th className="has-text-centered">Unit</th>
              <th className="has-text-centered">Action</th>
            </tr>
          </thead>
          {pegawai && pegawai.strRole === "user" && (
            <tbody>
              {riwayatKeluargas.map((riwayatKeluarga, index) =>
                riwayatKeluarga.strStatus === "Pengajuan Anggota Keluarga" ||
                riwayatKeluarga.strStatus === "Ditolak Kabid Kepegawaian" ? (
                  <tr key={riwayatKeluarga.uuid}>
                    {index === 0}
                    <td>{index + 1}</td>
                    <td>{riwayatKeluarga.strNamaKeluarga}</td>
                    <td>{riwayatKeluarga.strStatusKeluarga}</td>
                    <td>{riwayatKeluarga.strTempatLahir}</td>
                    <td>
                      {moment(riwayatKeluarga.dateTanggalLahir).format(
                        "DD/MM/YYYY"
                      )}
                    </td>

                    <td>{riwayatKeluarga.strPekerjaan}</td>
                    <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                    <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                    <td>
                      <a
                        href={riwayatKeluarga.url}
                        download
                        onClick={(e) => download(e)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-download" />
                        Akta Kelahiran
                      </a>
                    </td>
                    <td>{riwayatKeluarga.strStatus}</td>
                    <td>{riwayatKeluarga.strKomentar}</td>
                    <td>{riwayatKeluarga.pegawai.strNama}</td>
                    <td>{riwayatKeluarga.pegawai.strUnit}</td>

                    <td>
                      <Link
                        to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                        className="button is-small is-info"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() =>
                          deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                        }
                        className="button is-small is-danger"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ) : (
                  <tr key={[riwayatKeluarga.uuid]}>
                    {index === 0}
                    <td>{index + 1}</td>
                    <td>{riwayatKeluarga.strNamaKeluarga}</td>
                    <td>{riwayatKeluarga.strStatusKeluarga}</td>
                    <td>{riwayatKeluarga.strTempatLahir}</td>
                    <td>
                      {moment(riwayatKeluarga.dateTanggalLahir).format(
                        "DD/MM/YYYY"
                      )}
                    </td>

                    <td>{riwayatKeluarga.strPekerjaan}</td>
                    <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                    <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                    <td>
                      <a
                        href={riwayatKeluarga.url}
                        download
                        onClick={(e) => download(e)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-download" />
                        Akta Kelahiran
                      </a>
                    </td>
                    <td>{riwayatKeluarga.strStatus}</td>
                    <td>{riwayatKeluarga.strKomentar}</td>
                    <td>{riwayatKeluarga.pegawai.strNama}</td>
                    <td>{riwayatKeluarga.pegawai.strUnit}</td>

                    <td>-</td>
                  </tr>
                )
              )}
            </tbody>
          )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 1" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit ===
                    "PAUD IT Al Hasanah 1" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        <td>{index + 0}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 2" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit ===
                    "PAUD IT Al Hasanah 2" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 1" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit === "SDIT Al Hasanah 1" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 2" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit === "SDIT Al Hasanah 2" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMPI Al Hasanah" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit === "SMPI Al Hasanah" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMAIT Al Hasanah" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit === "SMAIT Al Hasanah" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "Pondok Pesantren" && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKeluarga, index) =>
                    riwayatKeluarga.pegawai.strUnit === "Pondok Pesantren" ? (
                      <tr key={[riwayatKeluarga.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKeluarga.strNamaKeluarga}</td>
                        <td>{riwayatKeluarga.strStatusKeluarga}</td>
                        <td>{riwayatKeluarga.strTempatLahir}</td>
                        <td>
                          {moment(riwayatKeluarga.dateTanggalLahir).format(
                            "DD/MM/YYYY"
                          )}
                        </td>

                        <td>{riwayatKeluarga.strPekerjaan}</td>
                        <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                        <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                        <td>
                          <a
                            href={riwayatKeluarga.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Akta Kelahiran
                          </a>
                        </td>
                        <td>{riwayatKeluarga.strStatus}</td>
                        <td>{riwayatKeluarga.strKomentar}</td>
                        <td>{riwayatKeluarga.pegawai.strNama}</td>
                        <td>{riwayatKeluarga.pegawai.strUnit}</td>
                        <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "admin" ||
              pegawai.strRole === "kabid kepegawaian") && (
              <tbody>
                {riwayatKeluargas
                  .filter(
                    (riwayatKeluarga) =>
                      riwayatKeluarga.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKeluarga.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )

                  .map((riwayatKeluarga, index) => (
                    <tr key={[riwayatKeluarga.uuid]}>
                      {index === 0}
                      <td>{index + 1}</td>
                      <td>{riwayatKeluarga.strNamaKeluarga}</td>
                      <td>{riwayatKeluarga.strStatusKeluarga}</td>
                      <td>{riwayatKeluarga.strTempatLahir}</td>
                      <td>
                        {moment(riwayatKeluarga.dateTanggalLahir).format(
                          "DD/MM/YYYY"
                        )}
                      </td>

                      <td>{riwayatKeluarga.strPekerjaan}</td>
                      <td>{riwayatKeluarga.strDetailPekerjaan}</td>
                      <td>{riwayatKeluarga.strNoBPJSKeluarga}</td>
                      <td>
                        <a
                          href={riwayatKeluarga.url}
                          download
                          onClick={(e) => download(e)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa fa-download" />
                          Akta Kelahiran
                        </a>
                      </td>
                      <td>{riwayatKeluarga.strStatus}</td>
                      <td>{riwayatKeluarga.strKomentar}</td>
                      <td>{riwayatKeluarga.pegawai.strNama}</td>
                      <td>{riwayatKeluarga.pegawai.strUnit}</td>

                      <td>
                        <Link
                          to={`/riwayat-keluarga/edit/${riwayatKeluarga.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKeluarga(riwayatKeluarga.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
          <div />
        </table>
      </div>
    </div>
  );
};

export default RiwayatKeluargaList;
